export default [
  'ResourceService',
  class CustomerService {
    constructor(resourceService) {
      this._resourceService = resourceService;
      this._API_BASE = '/customers';
    }

    updateAddress(id, address) {
      if (!id || !address) {
        return this._resourceService.errorPromise('customer:updateAddress: missing parameters');
      } else if (typeof address !== 'object') {
        return this._resourceService.errorPromise('invalid parameters');
      }
      return this._resourceService.put(`${this._API_BASE}/${id}`, address);
    }

    updatePhone(id, phone_number, zip) {
      if (!id || !phone_number || !zip) {
        return this._resourceService.errorPromise('customer:updatePhone: missing parameters');
      }
      return this._resourceService.patch(`${this._API_BASE}/${id}/phone`, {
        phone_number: phone_number,
        original_zip: zip
      });
    }

    getOrderHistory(id) {
      if (!id) {
        return this._resourceService.errorPromise('customer:getOrderHistory: missing parameters');
      }
      let columns = 'columns[]=order_number&columns[]=created_at&columns[]=item_count&columns[]=sale_net_price&columns[]=order_status&columns[]=payment_status&columns[]=shipment_status';

      return this._resourceService.get(`/users/${id}/orders?${columns}`);
    }

    getSavedPaymentMethod(id) {
      if (!id) {
        return this._resourceService.errorPromise('customer:getSavedPaymentMethod: missing parameters');
      }

      return this._resourceService.get(`/users/${id}/payment`);
    }

    updateSavedPaymentMethod(id, token, last4, cc_bin) {
      if (!id || !token || !last4 || !cc_bin) {
        return this._resourceService.errorPromise('customer:updateSavedPaymentMethod: missing parameters');
      }

      return this._resourceService.post(`/users/${id}/payment`, { token: token, last4: last4, cc_bin: cc_bin });
    }

    removeSavedPaymentMethod(id, payment) {
      if (!id || !payment) {
        return this._resourceService.errorPromise('customer:removeSavedPaymentMethod: missing parameters');
      }

      return this._resourceService.delete(`/users/${id}/payment/${payment}`);
    }

    trackAbandonedCart (email, campaignID, productID, hash = null) {
      if (!email || !campaignID || !productID) {
        return this._resourceService.errorPromise('missing parameters');
      }

      let payload = { 'email': email, 'pid': productID };
      if (hash !== null) payload['hash'] = hash;

      return this._resourceService.post(`${this._API_BASE}/track/${campaignID}`, payload);
    }

    convertTrackedCart (email, campaignID, orderNum) {
      if (!email || !campaignID || !orderNum) {
        return this._resourceService.errorPromise('customer:convertTrackedCart: missing parameters');
      }

      return this._resourceService.post(`${this._API_BASE}/track/${campaignID}/converted`, { 'email': email, 'order_id': orderNum });
    }

    optOutCart (hash) {
      if (!hash) {
        return this._resourceService.errorPromise('missing parameters');
      }

      return this._resourceService.post(`${this._API_BASE}/track/${hash}/optout`);
    }
  }
];



// WEBPACK FOOTER //
// ./source/client/api-services/customer-service.js